var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbLogoGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 42,
    viewBox: "0 0 53 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9653 1.19373L36.1579 -0.000160217L37.3102 1.15032L36.1177 2.34422L34.9653 1.19373Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0123 8.42549L34.0245 10.412L35.9466 12.3343L37.9343 10.3477L36.0123 8.42549Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.727 15.0227L21.0344 12.7167L23.42 15.1024L21.1125 17.4084L18.727 15.0227Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8717 16.844L33.0865 19.6284L35.7742 22.3154L38.5593 19.5309L35.8717 16.844Z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8855 5.88248L31.4779 4.28993L33.0152 5.82623L31.4227 7.41879L29.8855 5.88248Z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8854 4.28465L19.3481 5.82095L20.9406 7.41351L22.4778 5.87721L20.8854 4.28465Z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2082 10.4277L26.2095 8.42688L28.2108 10.4277L26.2095 12.4285L24.2082 10.4277Z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3355 12.7131L28.9499 15.0988L31.2574 17.4048L33.6429 15.0191L31.3355 12.7131Z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0983 5.72916L40.6863 4.14149L42.2233 5.67809L40.6352 7.26575L39.0983 5.72916Z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5464 12.5596L38.16 14.9445L40.4666 17.2514L42.853 14.8665L40.5464 12.5596Z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2362 10.2558L45.2239 8.26924L47.146 10.1915L45.1582 12.178L43.2362 10.2558Z",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.501 16.8565L13.8133 19.5434L16.5985 22.3278L19.2861 19.6409L16.501 16.8565Z",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1042 24.2088L21.1771 21.1366L24.3569 24.3155L21.2839 27.3876L18.1042 24.2088Z",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2073 16.8444L23.1529 19.8979L26.2073 22.9515L29.2617 19.8979L26.2073 16.8444Z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6017 29.0196L26.2039 25.4184L29.806 29.0196L26.2039 32.6207L22.6017 29.0196Z",
    fill: "#000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1902 21.1412L28.0105 24.3201L31.0834 27.3922L34.2632 24.2133L31.1902 21.1412Z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1962 28.7246L16.6551 25.268L20.2334 28.8465L16.7745 32.3032L13.1962 28.7246Z",
    fill: "#000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0469 29.5636L27.0694 33.5413L30.909 37.3785L34.8864 33.4007L31.0469 29.5636Z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4827 33.4026L21.3222 29.5655L25.2997 33.5432L21.4601 37.3804L17.4827 33.4026Z",
    fill: "#000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7255 25.2674L32.146 28.8448L35.6036 32.3027L39.183 28.7253L35.7255 25.2674Z",
    fill: "#000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3652 14.7814L49.7507 12.3957L52.0581 14.7017L49.6726 17.0875L47.3652 14.7814Z",
    fill: "#000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0787 16.6853L42.294 19.4702L44.9822 22.1567L47.7668 19.3718L45.0787 16.6853Z",
    fill: "#000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2157 24.1668L40.3953 20.9879L43.4682 24.06L40.2886 27.2389L37.2157 24.1668Z",
    fill: "#000"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29142 16.6871L4.60421 19.3745L7.38985 22.1584L10.0771 19.471L7.29142 16.6871Z",
    fill: "#000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90022 24.0515L11.9732 20.9794L15.1529 24.1582L12.0799 27.2304L8.90022 24.0515Z",
    fill: "#000"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3568 8.42313L14.4341 10.3447L16.4258 12.3365L18.3485 10.415L16.3568 8.42313Z",
    fill: "#000"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51999 14.8596L11.8274 12.5536L14.213 14.9393L11.9055 17.2453L9.51999 14.8596Z",
    fill: "#000"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6784 4.12884L10.1417 5.66568L11.7301 7.25304L13.2668 5.71619L11.6784 4.12884Z",
    fill: "#000"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23403 10.1874L7.15642 8.26555L9.14383 10.2524L7.22143 12.1743L5.23403 10.1874Z",
    fill: "#000"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2117 0.00242615L15.0601 1.15369L16.2535 2.34674L17.405 1.19547L16.2117 0.00242615Z",
    fill: "#000"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0.316406 14.7004L2.62422 12.3947L5.01097 14.7792L2.70316 17.0849L0.316406 14.7004Z",
    fill: "#000"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2216 34.1849L22.2442 38.1627L26.0837 41.9998L30.0612 38.0221L26.2216 34.1849Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbLogoGem);
export default __webpack_public_path__ + "static/media/vb-logo-gem.66f9c51328da4a7fbafc83ebf49efb77.svg";
export { ForwardRef as ReactComponent };